{
  "buttonNext": "Далі",
  "buttonFinish": "Завершити",
  "Text": {
    "welcomeIntro": [
      {
        "title": "Привіт {{name}}!",
        "desc": "Раді вітати на платформі Healthy Mind! \n\nЦя система створена для того, щоб ви могли краще розуміти стан учасників чи співробітників та надати їм необхідну підтримку та розвиток. \nРазом ми створюємо середовище, де кожен має змогу покращувати свій ментальний стан.",
        "content": {
          "image": "frame-7.png"
        }
      },
      {
        "title": "Як це працює?",
        "desc": "Healthy Mind використовує персоналізовані алгоритми для створення унікальних сценаріїв проходження діагностики та подальших рекомендацій, що дозволяють ефективно підтримувати ментальний стан учасників. Це ваш робочий інструмент для підтримки та збереження команди.",

        "content": { "image": "frame-8.png" }
      },
      {
        "title": "Це науково обґрунтовано",
        "desc": "Методи та інструменти, які ми використовуємо, базуються на доказовій медицині та сучасних дослідженнях. \n\nВи можете бути впевнені, що наш підхід підтримується актуальними науковими знаннями, щоб забезпечити ваших учасників чи співробітників надійною допомогою.",
        "content": { "image": "frame-9.png" }
      },
      {
        "title": "Це безпечно і конфіденційно",
        "desc": "Ми забезпечуємо повну конфіденційність та безпеку даних вашої організації. Інформація використовується виключно для аналізу та створення індивідуальних планів підтримки. Групи користувачів надають вам статистичну інформацію, коли в них є три або більше учасників. Це гарантує анонімність.",
        "content": { "image": "frame-10.png" }
      }
    ],

    "gettingStartedGuide": [
      {
        "title": "Початок роботи",
        "desc": "Тут ви можете створювати різні групи учасників, стежити за їх наповненням та керувати всіма процесами легко і зручно. \nМи зробили все, щоб ви мали всі необхідні інструменти під рукою.",
        "content": {
          "image": "frame-11.png"
        }
      },
      {
        "title": "Створити групу",
        "desc": "Щоб почати, просто вкажіть назву групи та натисніть 'створити групу'. Налаштування займає лічені хвилини, і ви зможете зручно координувати вашу команду, забезпечуючи їм потрібну підтримку.",
        "content": {
          "image": "frame-12.png"
        }
      },
      {
        "title": "Запросити учасників",
        "desc": "Відкривши групу, ви побачите список учасників та вікно для запрошення нових. \n\nЗапросити учасників можна: через додавання електронної пошти одного або кількох учасників, або перетягнувши  файл у форматі CSV у визначену область. \nЦе зручний спосіб керувати групами та забезпечувати ефективну взаємодію вашої команди.",
        "content": { "image": "frame-10.png" }
      }
    ]
  }
}
